function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import toTree from '../../internal/compiler/toTree';
import { NavigationConfigContext } from '../../internal/config/NavigationConfigContext';
import HrefContext from '../../internal/contexts/HrefContext';
import NavigationUiProvider from '../../internal/providers/NavigationUiProvider';
function mergeNavConfigs(defaults, config) {
    return _object_spread({}, defaults, config);
}
export default function NavigationProvider({ children, config }) {
    const currentNavigationInternalConfig = React.useContext(NavigationConfigContext);
    const { href, setHref, routes, unsafePreProcessRoute, postProcessUrl } = mergeNavConfigs(currentNavigationInternalConfig, config);
    const hrefValue = React.useMemo(()=>[
            href,
            setHref
        ], [
        href,
        setHref
    ]);
    const navigationConfigInternal = React.useMemo(()=>({
            routes,
            postProcessUrl,
            unsafePreProcessRoute
        }), [
        routes,
        postProcessUrl,
        unsafePreProcessRoute
    ]);
    toTree(config.routes);
    return /*#__PURE__*/ _jsx(NavigationConfigContext.Provider, {
        value: navigationConfigInternal,
        children: /*#__PURE__*/ _jsx(HrefContext.Provider, {
            value: hrefValue,
            children: /*#__PURE__*/ _jsx(NavigationUiProvider, {
                children: children
            })
        })
    });
}

//# sourceMappingURL=NavigationProvider.js.map